import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between gap-6" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-700 mb-1" }
const _hoisted_4 = { class: "text-[13px] leading-relaxed text-gray-500" }

import NeueToggle from '@/components/neue/NeueToggle.vue'


export default {
  __name: 'AgentToggleRow',
  props: {
  label: { type: String, required: true },
  help: { type: String, required: true },
  modelValue: { type: Boolean, default: false }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.label), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(props.help), 1)
    ]),
    _createVNode(NeueToggle, {
      "model-value": props.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (emit('update:modelValue', $event)))
    }, null, 8, ["model-value"])
  ]))
}
}

}